export default __webpack_public_path__ + "static/media/price.18c26fbf.svg";